"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var localStorageMgr = {};

localStorageMgr.setItem = function (key, value) {
  try {
    window.localStorage.setItem(key, value);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('[tab-cmp] localStorage not supported.', e);
  }
};

localStorageMgr.getItem = function (key) {
  try {
    var value = window.localStorage.getItem(key);
    return value;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('[tab-cmp] localStorage not supported.', e);
    return null;
  }
};

localStorageMgr.removeItem = function (key) {
  try {
    window.localStorage.removeItem(key);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('[tab-cmp] localStorage not supported.', e);
  }
};

var _default = localStorageMgr;
exports.default = _default;